// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N50, N500, N600, N70 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SyntaxHelpContainer = styled.div({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> a': {
    background: "var(--ds-background-neutral-bold, ".concat(N70, ")"),
    borderRadius: '100%',
    margin: "var(--ds-space-050, 4px)",
    '&:hover': {
      background: "var(--ds-background-neutral-bold-hovered, ".concat(N500, ")")
    },
    '&:focus': {
      background: "var(--ds-background-neutral-bold, ".concat(N70, ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:active, &[data-firefox-is-active='true']": {
      background: "var(--ds-background-neutral-bold-pressed, ".concat(N600, ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[disabled]': {
      background: "var(--ds-background-disabled, ".concat(N50, ")")
    }
  }
});